import { DND_CONDITIONS } from "./constants";

// Right-click token context menu — presentation only.
// Parent owns all mutations and passes callbacks.
export const VTTContextMenu = ({
  menu,
  onClose,
  onAttackAnim,
  onToggleDead,
  onOpenConditions,
  onToggleCondition,
  onChangeLayer,
  onToggleVisible,
  onRemove,
}) => {
  if (!menu) return null;
  const token = menu.token;
  const currentLayer = token.layer || "tokens";

  return (
    <div
      className="fixed z-50 bg-[#222] border border-[#444] rounded-lg shadow-xl py-1 min-w-[180px] max-h-[85vh] overflow-y-auto"
      style={{ left: menu.x, top: menu.y }}
      onClick={onClose}
      data-testid="token-context-menu"
    >
      <div className="px-3 py-1 border-b border-[#333]">
        <p className="text-xs text-white font-medium truncate">{token.name}</p>
        <p className="text-[9px] text-[#666]">Layer: {currentLayer}</p>
      </div>

      <button
        className="w-full text-left px-3 py-1.5 text-xs text-[#ccc] hover:bg-[#333] flex items-center gap-2"
        onClick={() => { onAttackAnim(token.id); onClose(); }}
        data-testid="ctx-attack-anim"
      >
        {"\u2694"} Attack (animate)
      </button>

      <button
        className="w-full text-left px-3 py-1.5 text-xs text-[#ccc] hover:bg-[#333] flex items-center gap-2"
        onClick={() => { onToggleDead(token.id); onClose(); }}
        data-testid="ctx-toggle-dead"
      >
        {token.is_dead ? "\u2764 Revive" : "\u2620 Mark Dead"}
      </button>

      <button
        className="w-full text-left px-3 py-1.5 text-xs text-[#ccc] hover:bg-[#333] flex items-center gap-2"
        onClick={() => { onOpenConditions(token); onClose(); }}
        data-testid="ctx-conditions"
      >
        {"\u26A1"} Conditions
      </button>

      {/* Quick conditions */}
      {DND_CONDITIONS.slice(0, 6).map((c) => (
        <button
          key={c.name}
          className="w-full text-left px-3 py-1 text-[10px] hover:bg-[#333] flex items-center gap-2"
          style={{ color: c.color }}
          onClick={() => { onToggleCondition(token.id, c.name); onClose(); }}
        >
          {(token.conditions || []).includes(c.name) ? "\u2713 " : ""}{c.name}
        </button>
      ))}

      {/* DM Layer controls */}
      <div className="border-t border-[#333] mt-1 pt-1">
        <p className="px-3 py-0.5 text-[9px] text-[#666] uppercase">Move to Layer</p>
        {["tokens", "gm", "map"].map((layer) => (
          <button
            key={layer}
            className={`w-full text-left px-3 py-1 text-[10px] hover:bg-[#333] ${currentLayer === layer ? "text-primary font-medium" : "text-[#ccc]"}`}
            onClick={() => { onChangeLayer(token.id, layer); onClose(); }}
            data-testid={`ctx-layer-${layer}`}
          >
            {currentLayer === layer ? "\u2713 " : ""}
            {layer === "tokens" ? "Token Layer" : layer === "gm" ? "GM Layer (hidden)" : "Map Layer"}
          </button>
        ))}
      </div>

      {/* Hide/Reveal + Remove */}
      <div className="border-t border-[#333] mt-1 pt-1">
        <button
          className="w-full text-left px-3 py-1.5 text-xs text-[#ccc] hover:bg-[#333]"
          onClick={() => { onToggleVisible(token.id, !token.visible_to_players); onClose(); }}
          data-testid="ctx-toggle-visible"
        >
          {token.visible_to_players ? "\u{1F441} Hide from Players" : "\u{1F441} Reveal to Players"}
        </button>
        <button
          className="w-full text-left px-3 py-1.5 text-xs text-red-400 hover:bg-[#333] flex items-center gap-2"
          onClick={() => { onRemove(token.id); onClose(); }}
          data-testid="ctx-remove"
        >
          {"\u2716"} Remove Token
        </button>
      </div>
    </div>
  );
};
